var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.042 2.042C4.76467 -0.680667 9.17899 -0.680667 11.9017 2.042C14.6243 4.76467 14.6243 9.17899 11.9017 11.9017L10.9513 12.8416C10.2508 13.5291 9.34187 14.413 8.22424 15.4936C7.52584 16.1689 6.41783 16.1688 5.71954 15.4934L2.92426 12.7744C2.57294 12.4294 2.27888 12.1385 2.042 11.9017C-0.680667 9.17899 -0.680667 4.76467 2.042 2.042ZM11.0524 2.89126C8.79877 0.637623 5.1449 0.637623 2.89126 2.89126C0.637623 5.1449 0.637623 8.79877 2.89126 11.0524L4.08195 12.2274C4.73763 12.8691 5.56191 13.6701 6.55451 14.6301C6.78727 14.8552 7.15661 14.8553 7.38941 14.6302L10.1076 11.9867C10.4831 11.6182 10.7981 11.3067 11.0524 11.0524C13.306 8.79877 13.306 5.1449 11.0524 2.89126ZM6.97183 4.78889C8.29914 4.78889 9.37514 5.86489 9.37514 7.1922C9.37514 8.5195 8.29914 9.5955 6.97183 9.5955C5.64452 9.5955 4.56852 8.5195 4.56852 7.1922C4.56852 5.86489 5.64452 4.78889 6.97183 4.78889ZM6.97183 5.98992C6.30783 5.98992 5.76956 6.5282 5.76956 7.1922C5.76956 7.85619 6.30783 8.39447 6.97183 8.39447C7.63583 8.39447 8.17411 7.85619 8.17411 7.1922C8.17411 6.5282 7.63583 5.98992 6.97183 5.98992Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/location-black.914b36be45d1590959dc2a2c41f9ae79.svg";
export { ForwardRef as ReactComponent };